<template>
  <div>
    <div class="card shadow">
      <div class="card-header bg-transparent">
        <div>
          <h3 class="mb-0">
            AMA Management Board 
          </h3>
          <TaskCreate />
        </div>
      </div>

      <div class="card-body">
        <b-container>
          <b-row>
            <router-link :to="{ name: 'create-activite'}">
            <b-button variant="outline-info">
              <i class="fas fa-plus"></i>
              {{ $t("message.add") }} <!--{{ $t("message.activity") }}/*-->
            </b-button>
          </router-link>
          </b-row>
          <b-row class="justify-content-sm-center">
              <Board />
          </b-row>
        </b-container>
      </div>
    </div>
  </div>
</template>

<script>

import Board from '../ama/Board.vue'
import TaskCreate from '../ama/CreateTask.vue'

export default {
  name: 'app',
  components: {
    Board,
    TaskCreate
  }
}
</script>
